import { useCallback } from 'react';
import { StateActions } from 'session/state/actions';
import { IGlobalState } from 'session/state/state';
import { useUserReducer } from 'session/state/user/userReducer';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useStateReducer = () => {
    const userReducer = useUserReducer();

    return useCallback(
        (state: IGlobalState, action: StateActions): IGlobalState => {
            const user = userReducer(state, action);
            if (user) return user;

            return state;
        },
        [userReducer]
    );
};
